import { render, staticRenderFns } from "./SocialRowMenu.vue?vue&type=template&id=ff5deda0&scoped=true"
import script from "./SocialRowMenu.vue?vue&type=script&lang=js"
export * from "./SocialRowMenu.vue?vue&type=script&lang=js"
import style0 from "./SocialRowMenu.vue?vue&type=style&index=0&id=ff5deda0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5deda0",
  null
  
)

export default component.exports